export const siteURL = 'https://api.bel-fast.rs';

export const baseURL = `${siteURL}/api`;
export const baseApiUrl = `${siteURL}/api/v1/`;
export const storageURL = `${siteURL}/storage/`;

export const publicURL = 'https://bel-fast-site.vercel.app/';
